export default "__VITE_ASSET__zxI6p$tC__"